export function PageHeader({ eyebrow, title, subtitle, actions }) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-3 sm:gap-4 mb-6 sm:mb-8">
      <div className="min-w-0">
        {eyebrow && <div className="text-[10px] sm:text-[11px] tracking-[0.25em] uppercase text-muted-foreground mb-1 sm:mb-2">{eyebrow}</div>}
        <h1 className="font-display text-2xl sm:text-4xl font-black tracking-tight leading-tight">{title}</h1>
        {subtitle && <p className="text-sm text-muted-foreground mt-1 sm:mt-2 max-w-2xl">{subtitle}</p>}
      </div>
      {actions && <div className="flex flex-wrap items-center gap-2">{actions}</div>}
    </div>
  );
}

export function Stat({ label, value, hint, testid, accent }) {
  return (
    <div data-testid={testid} className="tactical-card p-3 sm:p-5 hover:-translate-y-0.5 transition-transform">
      <div className="text-[10px] sm:text-[11px] tracking-widest uppercase text-muted-foreground">{label}</div>
      <div className={`stat-num mt-1 sm:mt-2 ${accent ? 'text-primary' : ''}`}>{value}</div>
      {hint && <div className="text-[11px] sm:text-xs text-muted-foreground mt-1">{hint}</div>}
    </div>
  );
}

export function PageShell({ children }) {
  return <div className="p-4 sm:p-8 max-w-[1400px]">{children}</div>;
}
